export const defaultColumns = ['parameter'];
